import * as React from 'react';
import { Label } from '@cian/ui-kit';

import { LABEL_BACKGROUNDS, LABEL_COLORS, LABEL_ICONS_MAP } from './constants';
import * as styles from './MortgagePromoCardLabel.css';
import { SEO_LABEL_TYPES, SEO_LABEL_TEXT } from '../../constants/seoLabels';
import { useListingWithPromosUrl } from '../../hooks';
import { ELabelType } from '../../types/promosPage';

interface IMortgagePromoCardLabelProps {
  newbuildingIds: number[];
  text: string;
  type: ELabelType;
}

export const MortgagePromoCardLabel: React.FC<IMortgagePromoCardLabelProps> = React.memo(
  ({ newbuildingIds, text, type }) => {
    const href = useListingWithPromosUrl(newbuildingIds);

    if (SEO_LABEL_TYPES.includes(type)) {
      return (
        <a href={href} onClick={event => event.stopPropagation()}>
          <span className={styles['seo-text']}>{SEO_LABEL_TEXT}</span>
          <Label
            background={LABEL_BACKGROUNDS[type]}
            color={LABEL_COLORS[type]}
            icon={<img src={LABEL_ICONS_MAP[type]} />}
          />
        </a>
      );
    }

    return (
      <Label background={LABEL_BACKGROUNDS[type]} color={LABEL_COLORS[type]}>
        {text}
      </Label>
    );
  },
);

MortgagePromoCardLabel.displayName = 'MortgagePromoCardLabel';
